import { tss } from 'tss-react';

export const useStyles = tss.create(() => ({
  root: {
    width: 600
  }
}));

export const sx = {
  alert: {
    marginBottom: 1.5
  },
  textField: {
    marginTop: 0,
    marginBottom: 2
  },
  saveButton: {
    marginTop: 1
  }
};
